/**
 * Elements that render as blocks by default — the UA-stylesheet defaults from
 * https://html.spec.whatwg.org/multipage/rendering.html (overview:
 * https://developer.mozilla.org/en-US/docs/Glossary/Block-level_content) plus
 * line-breaking extras BR and SUMMARY. The projection separates words when
 * crossing one; both sides share the set, so an omission merely merges words
 * in `exact` — cosmetic, never a wrong paint.
 */
export const BLOCK_TAGS: ReadonlySet<string> = new Set([
  'ADDRESS',
  'ARTICLE',
  'ASIDE',
  'BLOCKQUOTE',
  'BR',
  'CAPTION',
  'DD',
  'DETAILS',
  'DIALOG',
  'DIV',
  'DL',
  'DT',
  'FIELDSET',
  'FIGCAPTION',
  'FIGURE',
  'FOOTER',
  'FORM',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'HEADER',
  'HGROUP',
  'HR',
  'LI',
  'MAIN',
  'NAV',
  'OL',
  'P',
  'PRE',
  'SECTION',
  'SUMMARY',
  'TABLE',
  'TBODY',
  'TD',
  'TFOOT',
  'TH',
  'THEAD',
  'TR',
  'UL'
]);
